<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="name">
        <el-input v-model="queryParams.name" clearable placeholder="资费组名"></el-input>
      </el-form-item>
      <el-form-item prop="productName">
        <el-input v-model="queryParams.productName" clearable placeholder="套餐名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addItem">添加</el-button>
      </el-form-item>
    </el-form>
    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border>
        <el-table-column prop="id" label="ID" align="center" width="60"></el-table-column>
        <el-table-column prop="name" label="资费组名" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="serverInfoIds" label="资费列表" align="center">
          <template slot-scope="{row}">
            <el-tag v-for="(item,index) in row.productPriceList" :key="index" style="margin: 3px;" :class="{elTagClsaa:item.hit == 1}">{{item.productName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button size="mini" type="primary" plain  icon="el-icon-edit" @click="handleEdit(row.id)" >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="[10, 20, 30, 40]"  
        @size-change="handleSizeChange"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    <div>
    <el-dialog :title="title" :visible.sync="dialog" @close="closeDialog" :lock-scroll="false" width="680px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="propsParams" :rules="ruleValidate" ref="propsParams"> 
        <el-form-item label="资费组名:" prop="productGroupName " :label-width="LabelWidth">
          <el-input v-model="propsParams.productGroupName" autocomplete="off" style="width:95%" placeholder="请输入资费组名"></el-input>
        </el-form-item>
        <el-form-item label="资费套餐:" prop="productIdList" :label-width="LabelWidth">
          <el-select
            v-model="propsParams.productIdList"
            multiple
            default-first-option
            filterable
            placeholder="请选择资费套餐"
            style="width:95%"
          >
            <el-option
              v-for="item in optPackage"
              :key="item.id"
              :label="item.productName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog">取消</el-button>
        <el-button type="success" @click="saveDialog">确认</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import { productList } from "@/api/api.js"; //不分页套餐列表
import { addProductGroup } from "@/api/api.js"; //添加套餐组
import { productGroupPage } from "@/api/api.js"; //获取套餐组列表
import { productGroupInfo } from "@/api/api.js"; //获取套详情编辑时用
import { updateProductGroup } from "@/api/api.js"; //更新套餐组
export default {
  name: "group",
  data() {
    return {
      queryParams: {
        name:undefined,
        productName:undefined
      },
      page: 1,
      pageSize: 20,
      total: 20,
      tableData: [],
      options: [],
      title: "创建资费组",
      dialog: false,
      LabelWidth: "100px",
      propsParams: {},
      ruleValidate: {
        productGroupName: [
          { required: true, message: "请输入资费组名", trigger: "blur" },
          { min:3,max:12,message: "请输入3至12字母数字或汉字",trigger: "blur"}
        ],
        productIdList: [
          { required: true, message: "请输入资费套餐", trigger: "blur" }
        ]
      },
      optPackage: [],
    };
  },
  computed: {},
  methods: {
    // 获取列表
    queryInfo() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      productGroupPage(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    // 资费套餐下拉
    queryServerList() {
      productList().then(res => {
        if (res.data.code == 200) {
          this.optPackage = res.data.data;
          this.optPackage.map((item) => {
            item.productName = `${item.id}-${item.productName}`
          })
        }
      });
    },
    // 搜索
    search() {
      this.page = 1;
      this.queryInfo();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.queryInfo();
    },
    // 添加
    addItem() {
      this.dialog = true;
      this.title = "创建资费组";
      this.propsParams = {};
    },
    // 编辑
    handleEdit(id) {
      this.dialog = true;
      this.title = "编辑资费组";
      let params = {
        id:id
      }
      productGroupInfo(params).then(res => {
        this.propsParams = res.data.data;
      })
    },
    saveDialog() {
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          if (this.title == "创建资费组") {
            let params = {
              ...this.propsParams,
            };
            addProductGroup(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("创建套餐组成功");
                this.dialog = false;
                this.queryInfo();
              }else{
                this.$message.error(res.data.message);
              }
            });
          } else if (this.title == "编辑资费组") {
            let params = {
              ...this.propsParams,
            };
            updateProductGroup(params).then(res => {
              this.$message.success("编辑套餐组成功");
              this.dialog = false;
              this.queryInfo();
            });
          }
        }
      });
    },
    // 关闭弹窗
    closeDialog() {
      this.$refs.propsParams.clearValidate();
      this.dialog = false;
    },
    // 弹窗的取消按钮
    cancelDialog() {
      this.dialog = false;
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.queryInfo();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.queryInfo();
    }
  },
  created() {
    this.queryInfo();
  },
  mounted() {
  },
  activated(){
    this.queryServerList();
  }
};
</script>
<style scoped lang="less">
.elTagClsaa{
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
}

</style>